// @ts-nocheck
// @ts-ignore
import { getLanguages } from '@ladjs/country-language';
import { getCountryName } from 'sonata-static-storage/lib/helpers/countries.helpers';
import { CampaignFamilyEnum } from 'sonata-static-storage/lib/schemas/campaign/campaign.schema';

type CampaignTypes = keyof typeof CampaignFamilyEnum;

export const getCampaignsType = (campaings: Record<string, any>[]): 'all' | CampaignTypes => {
  const uniqueTypes = [...new Set(campaings.map(campaign => campaign.type))];

  return uniqueTypes.length === 1 ? uniqueTypes[0] : 'multi';
};

export const getAvailableLanguages = () => {
  return getLanguages()
    .filter(({ iso639_1: code, name }: { iso639_1: string; name: string }) => !!code && name?.length > 0)
    .map(({ iso639_1: code, name }: { iso639_1: string; name: string }) => ({
      code,
      name: name[0]
    }))
    .sort(({ name: name1 }: { name: string }, { name: name2 }: { name: string }) => (name1 > name2 ? 1 : -1));
};

export const getFormattedCountries = (campaings: Record<string, any>[]): string[] => {
  const allCountries = campaings.flatMap(campaing => campaing.countries);
  const uniqueCountries = Array.from(new Set(allCountries));
  return uniqueCountries.map(getCountryName);
};
